import {keys} from 'ts-transformer-keys';

import {
    Images,
    Messages
} from '~/shared/src/utilities/dataExtraction';
import {Query} from '~/shared/src/utilities/query';
import {DataDescriptor} from '~/shared/src/utilities/dataStructure';


type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;


export type ChartType = 'bar' | 'doughnut' | 'line' | 'pie' | 'polarArea' | 'radar';
export type LegendAlign = 'center' | 'end' | 'start';
export type LegendPosition = 'bottom' | 'hidden' | 'left' | 'right' | 'top';
export type TimeSeriesIntervalUnit = 'millisecond' | 'second' | 'minute' | 'hour' | 'day' | 'week' | 'month' | 'quarter' | 'year';

// CFG:Chart
export type Chart = {
    data : {
        id : number;
        key : string;
        name : string;

        type : ChartType;

        legendAlign : LegendAlign;
        legendPosition : LegendPosition;

        filters?: string;//ColumnFilter[];
        sorters?: string;//ColumnSorter[];

        timeSeriesIntervalCount? : number;  // only used for time-line
        timeSeriesIntervalEndAbsolute? : Date;  // only used for time-line
        timeSeriesIntervalEndRelative? : string;  // only used for time-line
        timeSeriesIntervalStartAbsolute? : Date;  // only used for time-line
        timeSeriesIntervalStartRelative? : string;  // only used for time-line
        timeSeriesIntervalUnit? : TimeSeriesIntervalUnit;  // only used for timeLine - setting this enables time-line
        timeSeriesShowIntervalSelector: boolean; // only used for timeLine
        timeSeriesShowTimeRangeSelector: boolean; // only used for timeLine

        xAxisLabelAttributePath? : string; // not used for time-line
        xAxisLabelQueryFieldName? : string; // not used for time-line
    };
    xAxisLabelDataDescriptor? : DataDescriptor; // not used for time-line
    query : Query;
    images : Images;
    messages : Messages;
    permissions : GroupPermissions;
};
export const chartDataProps = keys<Chart['data']>();
export const chartProps = keys<Chart>();
export const requiredChartProps = keys<RequiredOf<Chart>>();
